import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import axios from '../../services/axiosInstance';
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import AdminPageEvent from "../../components/web/layoutsadmin/AdminPageEvent";
import AdminSearchEvent from "../../components/web/layoutsadmin/AdminSearchEvent";
import {BsCaretDown, BsCaretUp} from "react-icons/bs";
import {MdKeyboardArrowDown} from "react-icons/md";
import commonClose from "../../assets/img/commonClose.png";
import commonCheck from "../../assets/img/commonCheck.png";
import IntegDetailPopup from "../../components/web/modal/IntegDetailPopup";
import maCateImg from "../../assets/img/m-a-cate.png";
import {useWebSocket} from "../../services/WebsocketContext";
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";

const safeNum = (val) => {
    if (val === null || val === undefined) return 0;
    const num = Number(val);
    return isNaN(num) ? 0 : num;
};

function AdminPaymentsListPg() {

    /** region DataTable */

    const [data, setData] = useState([]);

    /** endregion*/

    /** region Function */

    const LCAT = localStorage.getItem('adminToken');
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState('');
    const [userNm, setUserNm] = useState('');

    const [adminInfo, setAdminInfo] = useState([]);
    const selectAdminInfo = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response)=> {
                setAdminInfo(response.data[0])
            })
            .catch(()=> {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        selectAdminInfo();
    }, [])

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!adminInfo.mbNum || isSubscribedRef.current) return;

            if (!stompClient && !isConnected) {
                await websocketConnect(adminInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [adminInfo.mbNum, isConnected, stompClient]);


    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const startHandle = (e) => {
        setStartDate(e.target.value);
    };
    const endHandle = (e) => {
        setEndDate(e.target.value);
    };
    const stringStartDate = startDate.replace(/-/g, '');
    const stringEndDate = endDate.replace(/-/g, '');

    const currentDate = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(currentDate.getDate() - 7); // 1주일

    const defaultMonth = () => {
        const stringStartDate = formatDateChat(oneWeekAgo);
        const stringEndDate = formatDateChat(currentDate);
        setStartDate(stringStartDate);
        setEndDate(stringEndDate);
    }

    useEffect(() => {
        defaultMonth();
    }, []);

    const formatDateChat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const [perPg, setperPg] = useState(10); // ★ perPg만 사용하여 고정된 보여주기식 수량만 핸들링
    const handleSelectChange = (e) => {
        const newPerPage = parseInt(e.target.value);
        setperPg(newPerPage);
    };

    const [alertShow, setAlertShow] = useState(false);
    const [alertShow2, setAlertShow2] = useState(false);
    const msgConfirmData1 = "확인 하시겠습니까?";
    const msgConfirmData2 = "결제승인이 완료됩니다.";
    const msgConfirmData3 = "정말 취소하시겠습니까?";
    const msgConfirmData4 = "결제가 취소처리 됩니다.";
    const modalCancel = useCallback (() => {setAlertShow(false);})
    const modalCancel2 = useCallback(() => {setAlertShow2(false);})
    const alert = (()=> {setAlertShow(true)})
    const alert2 = (() => {setAlertShow2(true)})

    const [checked, setChecked] = useState([]);

    const checkBoxChange = (id) => {
        setChecked((prevSelectedData) => {
            if (prevSelectedData.includes(id)) {
                return prevSelectedData.filter((item) => item !== id);
            } else {
                return [...prevSelectedData, id];
            }
        });
    };

    const allcheckBoxChange = (e) => {
        const visibleIds = visibleData.map((item) => item.seqNum);
        if (e.target.checked) {
            setChecked((prev) => Array.from(new Set([...prev, ...visibleIds])));
        } else {
            setChecked((prev) => prev.filter((id) => !visibleIds.includes(id)));
        }
    };

    const [searchInput, setSearchInput] = useState('');
    const handleSearchInputChange = (event) => {
        setSearchInput(event.target.value);
    };

    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortOrder("asc");
        }
    };

    const selectedTotalPricePrint = (pay) => {
        if (!pay) return 0;

        let prodTotal = 0;
        let shipTotal = 0;
        let etcTotal = 0;
        let integTotal = 0;

        if (pay.payType === "PT0") {
            const ttEtcFee = safeNum(pay.ttEtcFee);
            const ttProdExpense = safeNum(pay.ttProdExpense);
            prodTotal += ttEtcFee + ttProdExpense;
            return prodTotal;
        } else if (pay.payType === "PT1") {
            const prices = [
                pay.ttFedexPrice, pay.ttFedexEcoPrice, pay.ttDhlPrice, pay.ttEmsPrice,
                pay.ttEmsPrePrice, pay.ttUpsPrice, pay.ttUpsEcoPrice, pay.ttKPackPrice,
                pay.ttAirSPrice, pay.ttSeaPrice, pay.ttDomPrice
            ].map(safeNum);
            const validPrice = prices.find(price => price > 0) || 0;
            shipTotal += validPrice;
            return shipTotal;
        } else if (pay.payType === "PT2") {
            const courierPay = safeNum(pay.courierPay);
            const returnFee = safeNum(pay.returnFee);
            const deliveryFee = safeNum(pay.deliveryFee);
            const repackFee = safeNum(pay.repackFee);
            const agencyFee = safeNum(pay.agencyFee);
            const removeFee = safeNum(pay.removeFee);
            const comprFee = safeNum(pay.comprFee);
            const etcPrice = safeNum(pay.etcPrice);
            const etcFee = safeNum(pay.etcFee);
            etcTotal += courierPay + returnFee + deliveryFee + repackFee + agencyFee + removeFee + comprFee + etcPrice + etcFee;
            return etcTotal;
        } else if (pay.payType === "PT3") {
            const ttProdPrice = safeNum(pay.ttProdExpense);
            const ttEtcFee = safeNum(pay.ttEtcFee);
            const ttEtcPrice = safeNum(pay.ttEtcPrice);
            const ttShipExpense = safeNum(pay.ttShipExpense);
            integTotal += ttProdPrice + ttEtcFee + ttEtcPrice + ttShipExpense;
            return integTotal;
        }
        return 0;
    };

    // ★ [최적화] 1단계: 검색어 확장 필터링 (결제타입 한글, 결제수단 한글/영문 대소문자, 총금액, 최종금액 포함)
    const filteredData = useMemo(() => {
        return data.filter((cData) => {
            if (cData.childFl || cData.payStatus === "PS0") return false;

            let matchesSearch = true;
            if (searchInput.trim() !== '') {
                const keyword = searchInput.toLowerCase().trim();

                // 1. 이름 및 주문번호 검색
                const userName = (cData.orderdtDTO?.memberDTO?.userName || '').toLowerCase();
                const orderNum = (cData.orderdtDTO?.orderNumber || '').toString().toLowerCase();

                // 2. 결제타입 한글 매칭 변환 검색
                const payTypeKorean = ({
                    'PT0': '상품',
                    'PT1': '배송료',
                    'PT2': '기타',
                    'PT3': '통합'
                }[cData.payType] || '').toLowerCase();

                // 3. 결제수단 한글 및 영어(대소문자 무관) 변환 검색
                const payWayText = ({
                    'PM00': '무통장입금',
                    'PM01': 'paypal',
                    'PM02': 'wechat',
                    'PM03': 'alipay',
                    'PM04': '적립금결제',
                    'PM05': '예치금결제',
                    'PM06': 'btoragepay(global)',
                    'PM07': 'btoragepay(korean)',
                    'PM08': 'globalcard',
                    'PM09': 'koreanpay'
                }[cData.payWay] || '').toLowerCase();

                // 4. 금액 필터링용 데이터 구성 (숫자 포맷과 쉼표 포맷 모두 포함)
                const totalPrice = selectedTotalPricePrint(cData);
                const lastPrice = safeNum(cData.lastPrice);

                const totalPriceStr = totalPrice.toString();
                const totalPriceLocale = totalPrice.toLocaleString();
                const lastPriceStr = lastPrice.toString();
                const lastPriceLocale = lastPrice.toLocaleString();

                matchesSearch =
                    userName.includes(keyword) ||
                    orderNum.includes(keyword) ||
                    payTypeKorean.includes(keyword) ||
                    payWayText.includes(keyword) ||
                    totalPriceStr.includes(keyword) ||
                    totalPriceLocale.includes(keyword) ||
                    lastPriceStr.includes(keyword) ||
                    lastPriceLocale.includes(keyword);
            }

            let matchesStatus = true;
            if (selectedPaymentStatus !== '') {
                if (Array.isArray(selectedPaymentStatus)) {
                    matchesStatus = selectedPaymentStatus.includes(cData.payStatus);
                } else {
                    matchesStatus = cData.payStatus === selectedPaymentStatus;
                }
            }

            return matchesSearch && matchesStatus;
        });
    }, [data, searchInput, selectedPaymentStatus]);

    // ★ [최적화] 2단계: 정렬 처리
    const sortedData = useMemo(() => {
        let sorted = [...filteredData];

        sorted.sort((a, b) => {
            const dateA = a.payTime ? new Date(a.payTime) : new Date(a.regTime);
            const dateB = b.payTime ? new Date(b.payTime) : new Date(b.regTime);
            return dateB - dateA;
        });

        if (sortColumn) {
            sorted.sort((a, b) => {
                let aValue = a.orderdtDTO?.orderNumber;
                let bValue = b.orderdtDTO?.orderNumber;

                if (sortColumn === "userName") {
                    aValue = a.orderdtDTO?.memberDTO?.userName || "";
                    bValue = b.orderdtDTO?.memberDTO?.userName || "";
                }

                if (aValue < bValue) {
                    return sortOrder === "asc" ? -1 : 1;
                } else if (aValue > bValue) {
                    return sortOrder === "asc" ? 1 : -1;
                } else {
                    return 0;
                }
            });
        }
        return sorted;
    }, [filteredData, sortColumn, sortOrder]);

    // ★ [최적화] 3단계: 복잡한 인덱스 계산 없이 단순히 0부터 선택한 perPg 개수까지만 정교하게 잘라옴
    const visibleData = useMemo(() => {
        return sortedData.slice(0, perPg);
    }, [sortedData, perPg]);

    // ★ [최적화] 전체선택 UI 동기화 판단
    const isAllVisibleChecked = useMemo(() => {
        if (visibleData.length === 0) return false;
        return visibleData.every((item) => checked.includes(item.seqNum));
    }, [visibleData, checked]);

    // ★ [최적화] 필터링 조건이 변경될 때마다 안전하게 선택했던 체크박스 내역을 비우도록 수정
    useEffect(() => {
        setChecked([]);
    }, [searchInput, selectedPaymentStatus, startDate, endDate, perPg]);



    const [confirmPaySt, setConfirmPaySt] = useState(false);
    const confirmPayMsg1 = "입금확인을 진행하시겠습니까?";
    const confirmPayMsg2 = "진행 시 결제완료로 처리됩니다";

    const [cancelPaySt, setCancelPaySt] = useState(false);
    const cancelPayMsg1 = "입금취소를 진행하시겠습니까?";
    const cancelPayMsg2 = "진행 시 결제대기로 처리됩니다";

    const [selectedSeqNum, setSelectedSeqNum] = useState(null);

    const openConfirmPaySt = ((seqNum) => {
        setSelectedSeqNum(seqNum);
        setConfirmPaySt(true);
    })
    const closeConfirmPaySt = (() => {
        setSelectedSeqNum(null);
        setConfirmPaySt(false);
    })

    const openCancelPaySt = ((seqNum) => {
        setSelectedSeqNum(seqNum);
        setCancelPaySt(true);
    })
    const closeCancelPaySt = (() => {
        setSelectedSeqNum(null);
        setCancelPaySt(false);
    })

    const [integPayDetailPopupSt, setIntegPayDetailPopupSt] = useState(false);
    const [integPaySeqnum, setIntegPaySeqnum] = useState(null);
    const integPayDetail = ((seqnum) => {
        setIntegPaySeqnum(seqnum);
        setIntegPayDetailPopupSt(true)
    })
    const integDetailPopupClose = (() => {
        setIntegPayDetailPopupSt(false);
    })
    useEffect(() => {
        if (integPaySeqnum !== null) {
            setIntegPayDetailPopupSt(true);
        }
    }, [integPaySeqnum]);

    const convertToShipco = ((dvType, defalutShipco) => {
        if (dvType === 'D00') {
            return '국내배송';
        } else if (dvType === 'D01') {
            return 'FedEx';
        } else if (dvType === 'D16') {
            return 'FedEx-E';
        } else if (dvType === 'D11') {
            return 'UPS';
        } else if (dvType === 'D17') {
            return 'UPS-E';
        } else if (dvType === 'D02') {
            return 'EMS';
        } else if (dvType === 'D15') {
            return 'EMSP';
        } else if (dvType === 'D04') {
            return 'DHL';
        } else if (dvType === 'D13') {
            return 'K-Packet';
        } else if (dvType === 'D14') {
            return 'Small-Packet';
        } else if (dvType === 'D03') {
            return 'SEA';
        } else {
            return defalutShipco;
        }
    });

    useEffect(() => {
        if (startDate && endDate) {
            select();
        }
    }, [startDate, endDate]);

    const select = () => {
        axios({
            method: 'get',
            url: '/order/selectPayinfo',
            headers: {
                Authorization: LCAT
            },
            params: {
                startDate: stringStartDate,
                endDate: stringEndDate
            }
        })
            .then((response) => {
                const paySt = response.data.filter(cData => cData.payWay !== null && cData.payWay !== '');

                // paySt.sort((a, b) => new Date(b.regTime) - new Date(a.regTime)); // 등록시간 기준

                // payTime(결제완료시간)이 null이 아니면 payTime 기준, null이면 regTime(등록시간) 기준으로 하여 두 데이터 최신순 정렬
                paySt.sort((a, b) => {
                    const dateA = a.payTime ? new Date(a.payTime) : new Date(a.regTime);
                    const dateB = b.payTime ? new Date(b.payTime) : new Date(b.regTime);
                    return dateB - dateA;
                });

                if (response.data[0] && response.data[0].orderdtDTO && response.data[0].orderdtDTO.memberDTO) {
                    setUserNm(response.data[0].orderdtDTO.memberDTO.userName);
                }

                setData(paySt);
                setChecked([]);

            })
            .catch(error => {
                console.log("adminErr[00] : ", error)
            });
    };

    // region Excel

    const date = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const DateViewValue = year + month + day;
    const excelDown = () => {
        try {
            const selectedRows = visibleData.filter((item) => checked.includes(item.seqNum));

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            function mapDataToExcelRow(item, index) {
                const paymentStatus = item.payStatus === 'PS1' ? '결제중' : item.payStatus === 'PS0' ? '결제대기' : '결제완료';

                const paymentType = {
                    'PT0': '상품',
                    'PT1': '배송료',
                    'PT2': '기타',
                    'PT3': '통합'
                }[item.payType] || item.payType;

                const paymentMethod = {
                    'PM00': '무통장입금',
                    'PM01': 'Paypal',
                    'PM02': 'Wechat',
                    'PM03': 'Alipay',
                    'PM04': '적립금결제',
                    'PM05': '예치금결제',
                    'PM06': 'BtoragePay(Global)',
                    'PM07': 'BtoragePay(Korean)',
                    'PM08': 'GlobalCard',
                    'PM09': 'KoreanPay'
                }[item.payWay] || item.payWay;

                return {
                    '번호': index + 1,
                    '이름': item.orderdtDTO.memberDTO.userName,
                    '주문번호': item.orderdtDTO.orderNumber,
                    '결제타입': paymentType,
                    '결제수단': paymentMethod,
                    '총금액': selectedTotalPricePrint(item),
                    '최종금액': item.lastPrice,
                    '앱할인': item.appSalePrice || 0,
                    '예치금사용': item.depUsePrice,
                    '적립금사용': item.pointUsePrice,
                    '쿠폰사용': item.couponUsePrice,
                    '결제상태': paymentStatus,
                    '결제일시': item.regTime,
                };
            }

            const sheetConfigs = {
                '결제내역': {
                    name: '결제내역',
                    columns: [
                        {header: '번호', key: '번호', hidden: false, width: 6, style: { alignment: { horizontal: 'center' }}},
                        {header: '이름', key: '이름', width: 18, style: { alignment: { horizontal: 'center' }}},
                        {header: '주문번호', key: '주문번호', width: 23, style: { alignment: { horizontal: 'center' }}},
                        {header: '결제타입', key: '결제타입', width: 10, style: { alignment: { horizontal: 'center' }}},
                        {header: '결제수단', key: '결제수단', width: 15, style: { alignment: { horizontal: 'center' }}},
                        {header: '총금액(\\)', key: '총금액', width: 12, style: { alignment: { horizontal: 'center' }}},
                        {header: '최종금액(\\)', key: '최종금액', width: 12, style: { alignment: { horizontal: 'center' }}},
                        {header: '앱할인', key: '앱할인', width: 10, style: { alignment: { horizontal: 'center' }}},
                        {header: '예치금사용', key: '예치금사용', width: 10, style: { alignment: { horizontal: 'center' }}},
                        {header: '적립금사용', key: '적립금사용', width: 10, style: { alignment: { horizontal: 'center' }}},
                        {header: '쿠폰사용', key: '쿠폰사용', width: 10, style: { alignment: { horizontal: 'center' }}},
                        {header: '결제상태', key: '결제상태', width: 12, style: { alignment: { horizontal: 'center' }}},
                        {header: '결제일시', key: '결제일시', width: 18, style: { alignment: { horizontal: 'center' }}},
                    ],
                }
            };

            const borderHeaderStyle = {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            };

            const applyBordersToRow = (row, border) => {
                row.eachCell({ includeEmpty: true }, (cell) => {
                    cell.border = border;
                });
            };

            const applyStylesToHeader = (sheet, height) => {
                const invisibleRow = sheet.getRow();
                invisibleRow.height = 1;

                const headerRow = sheet.getRow(1);
                headerRow.font = { name: '맑은 고딕', bold: true, size: 10 };
                headerRow.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                headerRow.height = height;

                headerRow.eachCell(() => {});
                applyBordersToRow(headerRow, borderHeaderStyle);
            };

            const createSheet = (name, columns) => {
                const sheet = workbook.addWorksheet(name);
                sheet.columns = columns;
                applyStylesToHeader(sheet, 23);
                return sheet;
            };

            const addRowsToSheet = (sheet, rows, border) => {
                rows.forEach((item) => {
                    const row = sheet.addRow(item);
                    for (let i = 1; i <= sheet.columns.length; i++) {
                        row.getCell(i).font = { name: '맑은 고딕', size: 10 };
                    }
                    applyBordersToRow(row, border);
                });
            };

            let transformedSelectedRows;
            transformedSelectedRows = selectedRows.map(mapDataToExcelRow);

            if (sheetConfigs) {
                const sheet = createSheet(sheetConfigs['결제내역'].name, sheetConfigs['결제내역'].columns);
                applyStylesToHeader(sheet, 23);
                addRowsToSheet(sheet, transformedSelectedRows, borderHeaderStyle);
            }

            let fileName = `결제내역_${DateViewValue}.xlsx`;
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        } catch (error) {
            console.error(error);
        }
    };

    // endregion

    const payDataSucc = (seqNum) => {
        axios({
            method: 'post',
            url: '/order/adminpayconfirm',
            headers: {
                Authorization: LCAT
            },
            params: {
                seqNum: seqNum,
            }
        })
            .then(async (response) => {
                closeConfirmPaySt();
                select();
                const mbNum = response.data;
                try {
                    if(stompClient && stompClient.connected) {
                        await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: mbNum}));
                    }
                } catch (error) {
                    console.warn("결제상태 업데이트 웹소켓 전송실패 : ", error);
                }
            })
            .catch((error) => {
                console.log("결제완료상태 업데이트 실패 : ", error);
            });
    };

    const payDataCancel = (seqNum) => {
        axios({
            method: 'post',
            url: '/order/adminpaycancel',
            headers: {
                Authorization: LCAT
            },
            params: {
                seqNum: seqNum
            }
        })
            .then(async (response) => {
                closeCancelPaySt();
                select();
                const mbNum = response.data;
                try {
                    if(stompClient && stompClient.connected) {
                        await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: mbNum}));
                    }
                } catch (error) {
                    console.warn("결제상태 업데이트 웹소켓 전송실패 : ", error);
                }
            })
            .catch((error) => {
                console.log("결제취소상태 업데이트 실패 : ", error);
            });
    };


    /** endregion Event */


    return (
        <div className="AdminPaymentsListPg">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">결제내역</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card">
                    <div className="admin-event-wrap">
                        <div className="admin-event-wrap-btn">
                            <AdminPageEvent perPg={perPg} handleSelectChange={handleSelectChange}/>
                            <AdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle}
                                           endHandle={endHandle}/>
                            <div style={{marginRight: "15px"}}>
                                <select className="admin-combo wd-110 ht-30 p-l-7 font-s-14 font-t-cont"
                                        onChange={(e) => {
                                            // PS3&PS4를 선택했을 때의 로직을 여기에 추가
                                            if (e.target.value === "PS2&PS3&PS4") {
                                                // 예시: PS3과 PS4가 선택되었음을 처리
                                                setSelectedPaymentStatus(["PS2", "PS3", "PS4"]);
                                            } else {
                                                // 그 외의 경우는 기존처럼 단일 값을 처리
                                                setSelectedPaymentStatus(e.target.value);
                                            }
                                        }}>
                                    <option value="">결제상태</option>
                                    <option value="PS1">결제중</option>
                                    <option value="PS2&PS3&PS4">결제완료</option>
                                    <option value="PS5">취소</option>
                                </select>
                            </div>
                            <AdminSearchEvent searchInput={searchInput}
                                              handleSearchInputChange={handleSearchInputChange}/>
                        </div>
                        <div className="admin-event-wrap-btn">
                            <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event"
                                    onClick={excelDown}>EXCEL
                            </button>
                        </div>
                    </div>
                    <div className="div-tb m-b-10">
                        <div className="div-tb-head ht-60">
                            <div style={{width: "40px"}}>
                            <input className="admin-input-chkBox m-0-a" type="checkbox"
                                       checked={isAllVisibleChecked}
                                       onChange={allcheckBoxChange}/>
                            </div>
                            <div style={{width: "40px"}}><p>번호</p></div>
                            <div style={{width: "150px"}}>
                                <p>이름</p>
                                {/*{sortColumn === "orderdtDTO.memberDTO.userName" && sortOrder === "asc" && (*/}
                                {/*    <BsCaretUp className="dark-font c-point m-t-5" style={{ display: "inline-block", float: "right" }} />*/}
                                {/*)}*/}
                                {/*{sortColumn === "orderdtDTO.memberDTO.userName" && sortOrder === "desc" && (*/}
                                {/*    <BsCaretDown className="dark-font c-point m-t-5" style={{ display: "inline-block", float: "right" }} />*/}
                                {/*)}*/}
                            </div>
                            <div style={{width: "200px"}}>
                                <p>주문번호</p>
                                {/*{sortColumn === "orderdtDTO.orderNumber" && sortOrder === "asc" && (*/}
                                {/*    <BsCaretUp className="dark-font c-point m-t-5" style={{ display: "inline-block", float: "right" }} />*/}
                                {/*)}*/}
                                {/*{sortColumn === "orderdtDTO.orderNumber" && sortOrder === "desc" && (*/}
                                {/*    <BsCaretDown className="dark-font c-point m-t-5" style={{ display: "inline-block", float: "right" }} />*/}
                                {/*)}*/}
                            </div>
                            <div style={{width: "100px"}}><p>결제타입</p></div>
                            <div style={{width: "100px"}}><p>결제수단</p></div>
                            <div style={{width: "140px"}}><p>총금액(&#8361;)</p></div>
                            <div style={{width: "140px"}}><p>최종금액(&#8361;)</p></div>
                            <div style={{width: "80px"}}><p>앱할인</p></div>
                            <div style={{width: "80px"}}><p>예치금사용</p></div>
                            <div style={{width: "80px"}}><p>적립금사용</p></div>
                            <div style={{width: "80px"}}><p>쿠폰사용</p></div>
                            <div style={{width: "80px"}}><p>결제상태</p></div>
                            <div style={{width: "140px"}}><p>등록 및 결제일시</p></div>
                            <div style={{width: "40px"}}></div>
                        </div>
                        {visibleData.map((cData, i) => (
                            <div key={i} className="div-tb-body ht-70">
                                <div style={{width: "40px"}}>
                                    <input className="admin-input-chkBox m-0-a" type="checkbox" name={cData.seqNum}
                                           checked={checked.includes(cData.seqNum)}
                                           onChange={() => checkBoxChange(cData.seqNum)}/>
                                </div>
                                <div style={{width: "40px"}}><p>{i + 1}</p></div>
                                <div style={{width: "150px"}}><p>{cData.orderdtDTO.memberDTO.userName}</p></div>
                                <div style={{width: "200px"}}><p>{cData.orderdtDTO.orderNumber}</p></div>
                                <div className="user-center" style={{width: "100px"}}>
                                    <p>{cData.payType === "PT0" ? "상품" : cData.payType === "PT1" ? "배송료" : cData.payType === "PT2" ? "기타" : "통합"}</p>
                                    {cData.payType === "PT3" ?
                                        <button onClick={() => integPayDetail(cData.seqNum)}
                                                className="m-t-2 admin-btn-B wd-50 ht-27 font-s-12 btn-click-event">내역</button> : null
                                    }
                                </div>
                                <div className="wd-100">
                                    <p>{cData.payWay === "PM00" ? "무통장입금" : cData.payWay === "PM01" ? "Paypal" : cData.payWay === "PM02" ? "Wechat" :
                                        cData.payWay === "PM03" ? "Alipay" : cData.payWay === "PM04" ? "적립금결제" : cData.payWay === "PM05" ? "예치금결제" :
                                            cData.payWay === "PM06" ? "BtoragePay(Global)" : cData.payWay === "PM07" ? "BtoragePay(Korean)" :
                                                cData.payWay === "PM08" ? "GlobalCard" : cData.payWay === "PM09" ? "KoreanPay" : null}</p>
                                </div>
                                <div className="wd-140">
                                    <p>{selectedTotalPricePrint(cData).toLocaleString()}</p>
                                </div>
                                <div className="user-center"
                                     style={{width: "140px", display: "flex", alignItems: "center"}}>
                                    <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                        <p>{cData?.lastPrice?.toLocaleString() || 0}</p>
                                        {cData?.cardFee > 0 &&
                                            <p>(+{cData?.cardFee?.toLocaleString()})</p>
                                        }

                                        {cData.lastForPrice > 0 ?
                                            <div className="user-center"
                                                 style={{flexDirection: "row", marginLeft: "3px"}}>
                                                <p style={{fontSize: "11px", marginLeft: "3px"}}>-</p>
                                                <p style={{
                                                    fontSize: "13px",
                                                    color: "darkorange",
                                                    marginLeft: "3px"
                                                }}>{cData.lastForPrice}</p>
                                                <p style={{fontSize: "11px", marginLeft: "3px"}}>{cData.forCurrency}</p>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                                <div style={{width: "80px"}}><p>{cData?.appSalePrice?.toLocaleString() || 0}</p></div>
                                <div style={{width: "80px"}}><p>{cData?.depUsePrice?.toLocaleString() || 0}</p></div>
                                <div style={{width: "80px"}}><p>{cData?.pointUsePrice?.toLocaleString() || 0}</p></div>
                                <div style={{width: "80px"}}><p>{cData?.couponUsePrice?.toLocaleString() || 0}</p></div>
                                <div style={{width: "80px"}}>
                                    <p style={{
                                        color: cData.payStatus === 'PS1' ? "#7C9EDC" : cData.payStatus === 'PS5' ? "#EB939D" : "#FFB378"
                                    }}>
                                        {cData.payStatus === 'PS1' ? "결제중" : cData.payStatus === 'PS5' ? "취소" : "결제완료"}
                                    </p>
                                </div>
                                <div className="wd-140">
                                    <p>
                                        {/*{cData.regTime}*/}
                                        {cData?.payTime ? cData.payTime : cData?.regTime}
                                    </p>
                                </div>
                                <div className="user-center" style={{width: "40px"}}>
                                    {cData.payStatus === 'PS1' && (
                                        <img className="c-point wd-28 ht-28 m-a-opc-07 img-hover-opc" alt="closeImage"
                                             src={commonCheck} onClick={() => openConfirmPaySt(cData.seqNum)}/>)}
                                    {(cData.payStatus === 'PS1' || cData.payStatus === 'PS2' && cData.orderdtDTO.orderStatus !== 'OS12') && (
                                        <img className="c-point wd-28 ht-28 m-a-opc-07 img-hover-opc" alt="closeImage"
                                             src={commonClose} onClick={() => openCancelPaySt(cData.seqNum)}/>)}
                                </div>
                            </div>
                        ))}
                    </div>
                    {/*{displayLimit >= 30 && data.length > displayLimit && (*/}
                    {/*    <div className="text-center m-t-20">*/}
                    {/*        <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기*/}
                    {/*            <MdKeyboardArrowDown className="m-l3 font-s-17"/>*/}
                    {/*        </button>*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>
            </div>
            {alertShow === true ? <MsgSelectModal alertShow={alertShow} eventHandle1={modalCancel} eventHandle2={payDataSucc} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow2 === true ? <MsgSelectModal alertShow={alertShow2} eventHandle1={modalCancel2} eventHandle2={payDataCancel} msgData1={msgConfirmData3} msgData2={msgConfirmData4}/> : null}
            { confirmPaySt ?
            <MsgSelectModal confirmPaySt={confirmPaySt} confirmPayMsg1={confirmPayMsg1} confirmPayMsg2={confirmPayMsg2}
                            closeConfirmPaySt={closeConfirmPaySt} selectedSeqNum={selectedSeqNum} payDataSucc={payDataSucc}/>
                :
                cancelPaySt ?
                    <MsgSelectModal cancelPaySt={cancelPaySt} cancelPayMsg1={cancelPayMsg1} cancelPayMsg2={cancelPayMsg2}
                                    closeCancelPaySt={closeCancelPaySt} selectedSeqNum={selectedSeqNum} payDataCancel={payDataCancel}/>
                    :
                    integPayDetailPopupSt ?
                        <IntegDetailPopup integDetailPopupClose={integDetailPopupClose} integPaySeqnum={integPaySeqnum}/>
                        :
                    null
            }
        </div>
    );
}

export default AdminPaymentsListPg
